import React from 'react';

import styles from './GlobalLoader.module.scss';

function GlobalLoader({ isVisible }) {
  if (isVisible) {
    return (
      <div className={styles.root}>
        <div className={styles.bar} />
      </div>
    );
  } else {
    return null;
  }
}

export default GlobalLoader;
